<ng-container *ngIf="detailsSetup$ | async as setup">
  <div class="dialog-top sp-details-dialog" [ngClass]="{ 'dialog-top--margin-bottom': !editMode }">
    <h6 mat-dialog-title>
      <a [href]="space | dataFormatter: { displayFn: setup.config.navigateToEntity }" target="_blank">{{
        space | dataFormatter: { displayFn: setup.config.title }
      }}</a>
    </h6>
    <button
      *ngIf="!editMode && hasEDPWriteAccess"
      mat-icon-button
      [matMenuTriggerFor]="menu"
      [disabled]="disableMenu()"
      class="sp-details-dialog-menu-button"
      [ngClass]="{ 'sp-details-dialog-menu-button--disabled': disableMenu() }"
    >
      <mat-icon>edit</mat-icon>
    </button>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div *ngIf="editMode">
    <span class="error-messages" [spFormErrorMsg]="detailsFormGroup" [multipleMessages]="true"></span>
  </div>
  <div mat-dialog-content class="sp-details-modal-content">
    <ng-container *ngIf="editMode">
      <div class="term-dates-summary flex-container flex-container--v-alignment mb-sm">
        <ng-container *ngFor="let eachSummary of setup.config?.summaryLabels">
          <div class="mb-sm">{{ eachSummary.label | xTranslate }}</div>
          <ng-container *ngFor="let field of eachSummary.fields">
            <div class="item mb-xs">
              <div class="item--label">{{ field.label | xTranslate }}</div>
              <div class="item--value">{{ space | dataFormatter: field }}</div>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <div class="actions">
        <ng-container *ngFor="let action of setup.config?.actions">
          <ng-container [ngSwitch]="action.inputType">
            <!-- CHECKBOX -->
            <ng-container *ngSwitchCase="'checkbox'">
              <div class="term-dates-summary item flex-container flex-a-center mt-sm">
                <div class="item--label">{{ action.label | xTranslate }}</div>
                <div>
                  <mat-checkbox (change)="action.actionFn($event, detailsFormGroup, space)"></mat-checkbox>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
    <form [formGroup]="detailsFormGroup">
      <!-- RENDER SUBSETS -->
      <ng-container *ngFor="let subset of setup.config.subsets">
        <!-- RENDER FIELDS -->
        <ng-container
          *ngTemplateOutlet="
            editMode || subset.inputType === 'progressBar' ? editableMode : readableMode;
            context: { columns: setup.columns, subset: subset }
          "
        ></ng-container>
      </ng-container>
    </form>
  </div>
  <div mat-dialog-actions>
    <p *ngIf="setup.config.footer" class="last-updated">
      <ng-container *ngIf="space | dataFormatter: setup.config.footer : { defaultTxt: '' }; else notUpdated">
        {{ 'overlayDetails.lastUpdated' | xTranslate }}
        <span>
          {{ space | dataFormatter: setup.config.footer : { defaultTxt: '', label: setup.config.footer.label } }}
        </span>
      </ng-container>
      <ng-template #notUpdated>
        {{ 'overlayDetails.noLastUpdateInfo' | xTranslate }}
      </ng-template>
    </p>
    <div *ngIf="editMode">
      <button mat-button color="primary" (click)="cancel()">
        {{ 'commonLabels.cancel' | xTranslate }}
      </button>
      <button mat-flat-button color="primary" [disabled]="disableSave$ | async" (click)="save()">
        {{ 'commonLabels.save' | xTranslate }}
      </button>
    </div>
  </div>
</ng-container>

<!-- OVERLAY MENU -->
<mat-menu class="mat-menu-content toolbar-menu-disabled" #menu="matMenu" xPosition="before">
  <ng-container *ngFor="let menu of overlayMenu">
    <button *ngIf="!menu.hidden" [class]="menu.class" [disabled]="menu.disabled" (click)="menu.action()" mat-menu-item>
      {{ menu.disableTranslate ? menu.text : (menu.text | xTranslate) }}
    </button>
  </ng-container>
</mat-menu>

<!-- EDITABLE FIELDS -->
<ng-template #editableMode let-subset="subset" let-columns="columns">
  <ng-container *ngIf="!subset.hideOnEdit">
    <ng-container [ngSwitch]="subset.inputType">
      <!-- PROGRESS BAR -->
      <ng-container *ngSwitchCase="'progressBar'">
        <ng-container *ngTemplateOutlet="progressBar; context: { subset: subset }"></ng-container>
      </ng-container>
      <!-- (DEFAULT) INPUT FIELD -->
      <ng-container *ngSwitchDefault>
        <ng-container *ngTemplateOutlet="inputField; context: { subset: subset, columns: columns }"></ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<!-- READABLE FIELDS -->
<ng-template #readableMode let-subset="subset" let-columns="columns">
  <div class="readable-field" [class]="subset.class">
    <p>{{ columns | dataFormatter: { displayFn: subset.labelFn } | xTranslate }}</p>
    <p
      *ngIf="
        !(space | dataFormatter: { displayFn: subset?.navigateToEntity } : { defaultTxt: null, label: null });
        else link
      "
    >
      {{ space | dataFormatter: subset }}
    </p>
    <ng-template #link>
      <a [href]="space | dataFormatter: { displayFn: subset.navigateToEntity }" target="_blank">{{
        space | dataFormatter: subset
      }}</a>
    </ng-template>
  </div>
</ng-template>

<!-- PROGRESS BAR FIELD -->
<ng-template #progressBar let-subset="subset">
  <div class="progressbar-field">
    <p *ngIf="space | dataFormatter: { displayFn: subset.labelFn } : { defaultTxt: '', label: 'test' }; else naTxt">
      {{ 'overlayDetails.term' | xTranslate }}
      <span>
        {{ space | dataFormatter: { displayFn: subset.labelFn } : { defaultTxt: '', label: subset.label } }}
      </span>
    </p>
    <ng-template #naTxt>
      <p>N/A</p>
    </ng-template>
    <mat-progress-bar
      mode="determinate"
      [class]="progressbarClass"
      [value]="space | dataFormatter: subset"
    ></mat-progress-bar>
  </div>
</ng-template>

<!-- INPUT FIELD -->
<ng-template #inputField let-subset="subset" let-columns="columns">
  <div class="editable-field" [class.unit]="subset.unit" [class.textarea]="subset.inputType === 'textarea'">
    <label [ngClass]="{ 'miq-form-input-label--required': subset.isRequired }" class="miq-form-input-label">
      {{ columns | dataFormatter: { displayFn: subset.labelFn } | xTranslate }}
    </label>
    <sp-input-fields
      [overlayFormControl]="
        subset.formGroup
          ? detailsFormGroup.controls[subset.formGroup].controls[subset.dataField]
          : detailsFormGroup.controls[subset.dataField]
      "
      [optionValues]="subset.values"
      [inputType]="subset.dataField ? subset.inputType : ''"
      [value]="space | dataFormatter: subset : { defaultTxt: null, rawData: true, label: null }"
      [class.invalid]="subset.formGroup && detailsFormGroup.controls[subset.formGroup].invalid"
      (emitNumericData)="numericChange($event, subset)"
    ></sp-input-fields>
    <sp-input-fields
      *ngIf="subset.unit"
      [overlayFormControl]="detailsFormGroup.controls[subset.formGroup].controls[subset.unit.dataField]"
      [optionValues]="subset.unit.values"
      [inputType]="subset.unit.dataField ? subset.unit.inputType : ''"
      [value]="space | dataFormatter: subset.unit : { defaultTxt: null, rawData: true, label: null }"
      [class.invalid]="subset.formGroup && detailsFormGroup.controls[subset.formGroup].invalid"
    ></sp-input-fields>
    <!-- ERROR MESSAGES -->
    <span
      class="error-message"
      [spFormErrorMsg]="
        subset.formGroup ? detailsFormGroup.controls[subset.formGroup] : detailsFormGroup.controls[subset.dataField]
      "
    ></span></div
></ng-template>
